/**
 * Generated runtime TestId mirror for frontend/src/components/ui/pagination.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const PaginationTestIds = {
  btnFirstPage: "btn-first-page",
  btnLastPage: "btn-last-page",
  btnNextPage: "btn-next-page",
  btnPreviousPage: "btn-previous-page",
  paginationInfo: "pagination-info",
  paginationPageInfo: "pagination-page-info",
  selectPageSize: "select-page-size"
} as const;
